// removed by extract-text-webpack-plugin
module.exports = {"brand":"_1TWAI9zVL4NjV5MJgpZxHn","brand--dark":"_1zZtU4LRDITjI1qHdOZkrv","brand--light":"wKsNz_wmwD8Yy48_EKPuV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Brand/brand.scss
// module id = 1161
// module chunks = 0